export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9098.faba1862.jpg";